"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.calcWidth = exports.calcPositionFromTime = exports.createTimeTicks = void 0;

var _luxon = require("luxon");

var _timeProvider = require("../time-provider");

var trackStepInMin = 5;
var pxPerMinute = 50 / trackStepInMin;

var createTimeTicks = function createTimeTicks(startEvent, endEvent) {
  var isoStart = (0, _timeProvider.convertEventTimeToISO)(startEvent.date, startEvent.time);
  var isoEnd = (0, _timeProvider.convertEventTimeToISO)(endEvent.date, endEvent.time);
  var ticks = (0, _timeProvider.createTimeRange)(isoStart, isoEnd, trackStepInMin);
  return ticks;
};

exports.createTimeTicks = createTimeTicks;

var calcPositionFromTime = function calcPositionFromTime(startEvent) {
  var k = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var isoStart = (0, _timeProvider.convertEventTimeToISO)(startEvent.date, startEvent.time);
  var secStart = (0, _timeProvider.iso2sec)(isoStart);
  return function (event) {
    var date = event.date,
        time = event.time,
        isoDate = event.isoDate,
        z = event.z; // events can have different date keys and formats
    // leaded to one type MMMM dd

    var correctDate = date || _luxon.DateTime.fromISO(isoDate, {
      setZone: true
    }).toFormat('MMMM dd');

    var local = (0, _timeProvider.convertEventTimeToLocal)(correctDate, time, z);
    var sec = local.sec;
    var dist = (sec - secStart) * pxPerMinute * k / 60;
    return dist;
  };
};

exports.calcPositionFromTime = calcPositionFromTime;

var calcWidth = function calcWidth(duration) {
  var k = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var mm = parseInt(duration, 10);
  var width = mm * pxPerMinute * k;
  return width;
};

exports.calcWidth = calcWidth;